@if (route()) {
  <a [class.border]="withBorder()"
     [class.full-height]="fullHeight()"
     [class.list-element]="listElement()"
     [class.warning]="warning()"
     [ngClass]="{'flex-row vertical-center': textCenteredVertically()}"
     [routerLink]="route() ? route() : undefined"
     class="work-ui-infoblock flex gap-12 clickable"
     tabindex="0"
     data-testid="routerLink">
    <ng-container *ngTemplateOutlet="infoblockContent"></ng-container>
  </a>
} @else if (href()) {
  <a [class.border]="withBorder()"
     [class.full-height]="fullHeight()"
     [class.list-element]="listElement()"
     [class.warning]="warning()"
     [href]="href() ? href() : null"
     [ngClass]="{'flex-row vertical-center': textCenteredVertically()}"
     [target]="externalLink() ? '_blank' : '_self'"
     class="work-ui-infoblock flex gap-12 clickable"
     tabindex="0"
     data-testid="htmlLink">
    <ng-container *ngTemplateOutlet="infoblockContent"></ng-container>
  </a>
} @else {
  <div
    #staticDiv
    [class.border]="withBorder()"
    [class.clickable]="clickable()"
    [class.full-height]="fullHeight()"
    [class.list-element]="listElement()"
    [class.warning]="warning()"
    [ngClass]="{'flex-row vertical-center': textCenteredVertically()}"
    [attr.tabindex]="clickable() ? 0 : null"
    (keydown.enter)="clickable() && staticDiv.click()"
    class="work-ui-infoblock flex gap-12"
    data-testid="staticDiv">
    <ng-container *ngTemplateOutlet="infoblockContent"></ng-container>
  </div>
}



<ng-template #infoblockContent>
  <div [class.avatar]="withAvatar()"
       class="work-ui-infoblock__icon">
    @if (withAvatar()) {
      <work-ui-avatar
        [imgSrc]="avatarImgSrc()"
        [size]="avatarSize()"
        [square]="avatarSquare()"
        [status]="avatarStatus()" data-testid="avatar"/>
    } @else {
      <work-ui-icon
        [name]="iconName()">
      </work-ui-icon>
    }
  </div>
  <div class="work-ui-infoblock__text">
    @if (label()) {
      <label class="flex flex-row vertical-center gap-4">
        <small [innerHTML]="label()"></small>
        @if (labelTooltip()) {
          <work-ui-icon class="cursor-help" name="info" [fontSize]="14" [workUiTooltip]="labelTooltip() || ''" [workUiTooltipMaxWidth]="360" />
        }
      </label>
    }
    @if (title()) {
      <p><b [innerHTML]="title()"></b></p>
    }
    @if (subtitle()) {
      <small [innerHTML]="subtitle()" class="work-text-color-light"></small>
    }
  </div>
</ng-template>
